import React from 'react'
import { FaCheckCircle } from 'react-icons/fa'
import '@resources/css/catalogo/compatibility-banner.css'

type Props = {
  state: 'offer' | 'info' | 'none'
  count: number
  treatmentLabel: string
  isOpen: boolean
  onToggle: () => void
}

const CompatibilityBanner: React.FC<Props> = ({ state, count, treatmentLabel, isOpen, onToggle }) => {
  if (state === 'none') return null

  return (
    <div className="compatibility-banner-card">
      <span className="compatibility-banner-icon"><FaCheckCircle size={22} /></span>
      <div className="compatibility-banner-content">
        <span className="compatibility-banner-eyebrow">
          {state === 'offer' ? 'MAIS OPÇÕES PARA O SEU TRATAMENTO' : 'VOCÊ JÁ ESTÁ VENDO TODAS AS OPÇÕES'}
        </span>
        <h5 className="compatibility-banner-title">
          Amostras de Inseminação também podem ser usadas em {treatmentLabel}
        </h5>
        {state === 'offer' ? (
          <p className="compatibility-banner-text mb-0">
            Encontramos mais <b>{count} {count === 1 ? 'doador' : 'doadores'}</b> com amostras disponíveis para
            Inseminação. Esse tipo de amostra também pode ser usada em {treatmentLabel}, o que amplia suas opções de
            escolha. Confirme com sua clínica antes de reservar.
          </p>
        ) : (
          <p className="compatibility-banner-text mb-0">
            Os doadores com amostra para Inseminação já aparecem nesta lista, identificados pelo ícone
            Inseminação. Confirme com sua clínica antes de reservar.
          </p>
        )}
      </div>
      {state === 'offer' && (
        <button type="button" className="btn btn-primary compatibility-banner-toggle" onClick={onToggle}>
          {isOpen ? 'Ocultar' : `Ver ${count} ${count === 1 ? 'doador' : 'doadores'}`}
        </button>
      )}
    </div>
  )
}

export default CompatibilityBanner
